import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App.js'
import { bootFromCache } from './design/live-control/prefs.js'
import { isAuthPath } from './design/live-control/router.js'
import { bootAppEntry } from './design/live-control/shell/auth-motion.js'

// AVANT le premier rendu : thème/accent/branding depuis le cache local —
// pas de flash « défaut → personnalisé ». Le serveur corrigera ensuite.
// L'ordre compte : `bootAppEntry` lit la préférence de mouvement que
// `bootFromCache` vient de poser sur <html>.
bootFromCache()

// Entrée dans l'application (§7). Le parcours d'authentification a déjà sa
// propre chorégraphie : on ne retient pas l'écran de connexion.
if (!isAuthPath(window.location.pathname)) bootAppEntry()

const racine = document.getElementById('root')
if (!racine) throw new Error("Élément #root introuvable dans index.html")

createRoot(racine).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
